/* eslint-disable no-param-reassign */
import { produce } from 'immer';

import { FETCH_TVA_VALUES_REQUEST, FETCH_TVA_VALUES_SUCCESS, FETCH_TVA_VALUES_FAILURE } from 'constants/ActionTypes';

/**
 * @typedef {{
 *   code: string,
 *   name: string,
 *   value: number,
 * }} TVA
 */

/**
 * @typedef {{
 *   data: TVA[],
 *   isFetching: boolean,
 * }} TVAReducer
 */

const initialState = {
  data: [],
  isFetching: false,
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case FETCH_TVA_VALUES_REQUEST:
      draft.isFetching = true;
      break;
    case FETCH_TVA_VALUES_SUCCESS:
      draft.isFetching = false;
      draft.data = action.values;
      break;
    case FETCH_TVA_VALUES_FAILURE:
      draft.isFetching = false;
      break;
    default:
  }
}, initialState);

export default reducer;
